// NFT Collection Contract Address
export const NFT_CONTRACT_ADDRESS = 'NUBC4twKVnuXfPgZwSmNVSnvgiGDKuTLAMUsHXBsJuA';
